import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import { createExpiringStorage } from '@/utils/storage'

import type { Customer } from '@/graphql/generated-types'

// ✅ Jotai atom with local storage persistence
export const customersAtom = atom<Customer[]>([])
export const customerAtom = atomWithStorage<Customer | null>(
  'customer',
  null,
  createExpiringStorage<Customer | null>(10 * 60 * 1000)
)

export const currentCustomerTabAtom = atom<
  'slideshows' | 'slides' | 'media library'
>('slideshows')
